import { ProductVariantOption } from '@prisma/client';
import {
  CartItem,
  ProductWithRelations,
  VariantSelection,
} from 'Types';

type SelectedVariantWithGroupId = ProductVariantOption & {
  groupId: string;
};

export const getSelectedVariants = (
  product: ProductWithRelations,
  variantSelection: VariantSelection
): SelectedVariantWithGroupId[] => {
  if (!variantSelection) return [];
  const selectedVariants: SelectedVariantWithGroupId[] = [];
  Object.keys(variantSelection).forEach((variantGroupId) => {
    const selectedVariantId = variantSelection[variantGroupId];
    if (selectedVariantId) {
      const variantGroup = product.variants.find(
        (v) => v.id === variantGroupId
      );
      const variantOption = variantGroup?.options.find(
        (o) => o.id === selectedVariantId
      );
      if (variantOption) {
        selectedVariants.push({ ...variantOption, groupId: variantGroupId });
      }
    }
  });
  return selectedVariants;
};

export const getProductTotalPrice = ({
  product,
  variantSelection,
  count,
}: {
  product: ProductWithRelations;
  variantSelection: VariantSelection;
  count: number;
}) => {
  let sum = product.price_promotional || product.price;

  getSelectedVariants(product, variantSelection).forEach((variant) => {
    sum += variant.price;
  });

  return sum * count;
};

export const getCartTotalPrice = (products: CartItem[]) => {
  let sum = 0;
  for (let i = 0; i < products.length; i++) {
    const item = products[i];
    const price = getProductTotalPrice({
      product: item.product,
      variantSelection: item.variantSelection,
      count: item.count,
    });
    sum += price;
  }
  return sum;
};

export const getCartQuantity = (products: CartItem[]) => {
  let sum = 0;
  for (let i = 0; i < products.length; i++) {
    const item = products[i];
    const quantity = item.count;

    sum += quantity;
  }
  return sum;
};
